/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { MailboxOAuthStartRequestIntent } from './mailboxOAuthStartRequestIntent';
import type { MailboxOAuthStartRequestProvider } from './mailboxOAuthStartRequestProvider';

export interface MailboxOAuthStartRequest {
  provider: MailboxOAuthStartRequestProvider;
  intent?: MailboxOAuthStartRequestIntent;
  mailbox_id?: string | null;
  set_as_default?: boolean;
  signature_id?: string | null;
}
